import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { logError } from '@/helpers/log-helper';

function StoreAvailability(_x, _x2, _x3) {
  return _StoreAvailability.apply(this, arguments);
}

function _StoreAvailability() {
  _StoreAvailability = _asyncToGenerator(function* (context, reference, zipcode) {
    var locale = context.state.i18n.currentLocale;
    var xhrUri = "/nav/nav-api/product/".concat(locale.market, "/").concat(locale.language, "/shops-by-address/").concat(reference, "/").concat(zipcode);

    try {
      var {
        data
      } = yield context.$axios.get(xhrUri, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      return data;
    } catch (e) {
      logError({
        msg: e,
        context
      });
      return null;
    }
  });
  return _StoreAvailability.apply(this, arguments);
}

export default StoreAvailability;